import { createFileRoute } from "@tanstack/react-router";
import { ByggeledelsePage, byggeledelseHead } from "@/pages/ByggeledelsePage";

export const Route = createFileRoute("/en/construction-management")({
  head: () => byggeledelseHead("en"),
  component: () => <ByggeledelsePage locale="en" />,
});
